import React, { useCallback, useEffect, useRef, useState } from 'react'
import { Button, Col, Input, Row, Switch, message } from 'antd'
import { SearchOutlined, EyeOutlined } from "@ant-design/icons";
import PaginatedTable from '../../../common/PaginatedTable';
import { Link } from 'react-router-dom';
import { useHistory, useLocation } from 'react-router-dom';
import Nodata from "../../../../assets/images/support/nodata.png";
import SupportLoader from '../../../../utils/Config/SupportLoader';
import { ApiRoutes } from '../../../../utils/Config/ApiRoutes';
import AxiosService from '../../../../utils/Config/ApiService';

const LeadList = () => {

  const pageNumberLimit = 3

  const [pageloader, setpageloader] = useState(true)
  const [maxPageNumberLimit, setMaxPageNumberLimit] = useState(5);
  const [minPageNumberLimit, setMinPageNumberLimit] = useState(0);

  let [validToken, setValidToken] = useState(false);
  let renderRef = useRef(false);
  const [messageApi, contextHolder] = message.useMessage();

  let [totalCount, setTotalCount] = useState(0)
  let [currentPage, setCurrentPage] = useState(1)
  let [itemsPerPage, setItemsPerPage] = useState(10)
  let [searchKey, setSearchKey] = useState("")
  let [leads, setLeads] = useState([])

  let [isloader, setisloader] = useState(true)

  let {search} = useLocation()
  let history = useHistory()
  const location = useLocation();

  const column = [
    {
      heading: () => '#',
      cell: (row, i) => {
          return i;
      },
      hidden: false,
      width: "20",
      id: 1
    },
    {
      heading: () => "Lead Name",
      cell: row => row["leadName"],
      hidden: false,
      width: "100",
      id: 2
    },
    {
      heading: () => "Phone Number",
      cell: row => row['phoneNumber'],
      hidden: false,
      width: "100",
      id: 3
    },
    {
      heading: () => "Distributor Name",
      cell: row => row['distributorName'],
      hidden: false,
      width: "120",
      id: 4
    },
    {
      heading: () => "Agent Name",
      cell: row => row['agentName'],
      hidden: false,
      width: "100",
      id: 5
    },
    {
      heading: () => "Campaign Name",
      cell: row => row['campaignName'],
      hidden: false,
      width: "100",
      id: 6
    },
    {
      heading: () => "Status",
      cell: row => {   
        if(row['status'] === 1){
          return  <span style={{color : "#488f42" , backgroundColor: "#ebfce3", paddingLeft:"4px",paddingRight : "4px", fontWeight: "600"}}>Hot</span>
        }else if(row['status'] === 0){
          return <span style={{color : "#eb5f50" , backgroundColor: "#ffeceb", paddingLeft:"4px", paddingRight : "4px",fontWeight: "600"}}>Lost</span>
        }
      },
      hidden: false,
      width: "100",
      id: 7
    },
    {
      heading: () => "Actions",
      cell: row => {
        // sessionStorage.setItem("searchKey", searchKey)
        return <>
          {
            <>
            <Switch className='mr-1' defaultChecked={row['status'] === 1 ? true : false} onChange={()=>toggleLead(row['leadId'])} size='small'/>
            <Link to={`/distributor/leadAdmin/view/${row.leadId}`} className="btn--small btn--view"><EyeOutlined /></Link>
            </>
          }
        </>
      },
      hidden: false,
      width: "20",
      id: 8
    }
  ]

  const verifyToken = async()=>{
    let query = new URLSearchParams(search)
    let token;

    if(query.get('token'))
    {
      token = query.get('token')
      sessionStorage.setItem('token',query.get('token'))
    }
    else
    {
      token = sessionStorage.getItem('token')
    }

    if(token)
    {
      try {
        let res = await AxiosService.post(`${ApiRoutes.SUPPORT_VERIFY_TOKEN.service}${ApiRoutes.SUPPORT_VERIFY_TOKEN.url}`,{token})
        if(res.status===200)
        {
          sessionStorage.setItem('userData',JSON.stringify(res.data.userData))
          sessionStorage.setItem('supportToken',(res.data.token))
          setValidToken(true);
          history.push('/distributor/leadAdmin')
        }
      } catch (error) {
        if(error.response.status===400){
          alert('Session Expired')
          history.push('/')
        }
        else{
          alert('Error Occoured. Login Again')
          history.push('/')
        }
      }
    }
    else
    {
      alert('No token found')
      history.push('/')
    }
  }  
  
  const getLeadList = async() => {      
    try{
      const response = await AxiosService.get(`${ApiRoutes.GET_LEAD.service}${ApiRoutes.GET_LEAD.url}`,{
        params : {
          pgno : currentPage,
          limit : itemsPerPage,
          searchKey : searchKey
        }
      });

      if(response.status === 200){
        setisloader(false)
        setLeads(response.data.data)
        setTotalCount(response.data.count)
        setpageloader(false) 
      }
    }catch(error){
      console.log(error)
      messageApi.open({
        type: "error",
        content: error.response.data.error ?? error.response.data.message
      })
    }
  }

  const toggleLead = async (id) => {
    try{
      const response = await AxiosService.put(`${ApiRoutes.TOGGLE_LEAD.service}${ApiRoutes.TOGGLE_LEAD.url}${id}`);
      if(response.status === 200){
        getLeadList();
      }
    }catch(error){
      console.log(error)
      alert(error.response.data.error ?? error.response.data.message)
      getLeadList();
    }
  }

  useEffect(()=>{
    verifyToken()
  },[])

  useEffect(() => {
    if (renderRef.current == true) {
      const delayFn = setTimeout(() => {
        currentPage == 1 ? getLeadList() : setCurrentPage(1);
      }, 1000);
      return () => clearTimeout(delayFn);
    } else {
      renderRef.current = true;
    }
  }, [searchKey]);

  useEffect(() => {
      validToken && getLeadList();
  },[currentPage, itemsPerPage, validToken])

  return (
    <>
    {contextHolder}
    <div className="adminContentSection">
      <Row gutter={8}>
        <Col span={10}>
          <Input 
            size="large"
            id="search"
            placeholder="Search by Campaign Name, Distributor Name..." 
            prefix={<SearchOutlined />} 
            className="supportSearchBox"
            value={searchKey}
            onClick={() =>{
              setTotalCount(0)
            }}
            onChange={(e) => {
              const regex = /^[ ]/g
              if(regex.test(e.target.value)){
                e.target.value?.replace(/^[ ]/g,"")
              }else{
                setpageloader(true)
                setSearchKey(e.target.value)
              }
            }}
          />              
        </Col>
        <Col span={4}>
          <div>
            <select style={{width : "85%"}} 
              defaultValue={itemsPerPage}
              onChange={(e) => {
                setItemsPerPage(Number(e.target.value));
                setCurrentPage(1);
                setMaxPageNumberLimit(pageNumberLimit);
                setMinPageNumberLimit(0);
              }}
            >
              <option value={5}>5</option>
              <option value={10}>10</option>
              <option value={25}>25</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
            </select>
          </div>
        </Col>
      </Row> 
        {
          isloader ? <SupportLoader/> :
          (!!leads.length) ? <PaginatedTable
            row={leads}
            column={column}
            totalCount={totalCount}
            itemsPerPage={itemsPerPage}
            setItemsPerPage={setItemsPerPage}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            isFilterHeader={false}
            isSearch = {false}
            maxPageNumberLimit={maxPageNumberLimit}
            setMaxPageNumberLimit={setMaxPageNumberLimit}
            minPageNumberLimit={minPageNumberLimit}
            setMinPageNumberLimit={setMinPageNumberLimit}
            isloader = {isloader}
            setpageloader={setpageloader}
            pageloader={pageloader}
            isvisible = {false}            
          /> : <div className="text-center p-x8-y16 bg-white mt30"><img src={Nodata} alt='icon'/></div>
        }
    </div>
    </>
  )
}

export default LeadList